export const SDK_VERSION = '6.17.7';
